// Login
export const SET_SIGNIN_STEP = "SET_SIGNIN_STEP";
export const FETCH_GET_CURRENT_USER = "FETCH_GET_CURRENT_USER";
export const FETCH_GET_CURRENT_USER_SUCCESS = "FETCH_GET_CURRENT_USER_SUCCESS";
export const FETCH_GET_CURRENT_USER_ERROR = "FETCH_GET_CURRENT_USER_ERROR";
export const FETCH_GET_LOGIN_OTP = "FETCH_GET_LOGIN_OTP";
export const FETCH_GET_LOGIN_OTP_SUCCESS = "FETCH_GET_LOGIN_OTP_SUCCESS";
export const FETCH_GET_LOGIN_OTP_ERROR = "FETCH_GET_LOGIN_OTP_ERROR";
export const FETCH_POST_VERIFY_LOGIN_OTP = "FETCH_POST_VERIFY_LOGIN_OTP";
export const FETCH_POST_VERIFY_LOGIN_OTP_SUCCESS = "FETCH_POST_VERIFY_LOGIN_OTP_SUCCESS";
export const FETCH_POST_VERIFY_LOGIN_OTP_ERROR = "FETCH_POST_VERIFY_LOGIN_OTP_ERROR";
export const SET_ENTERED_WRONG_PASSWORD = "SET_ENTERED_WRONG_PASSWORD";
export const SET_USER_MAPPED_TO_OTHER_AGENT = "SET_USER_MAPPED_TO_OTHER_AGENT";
export const SET_OTP_VERIFIED = "SET_OTP_VERIFIED";
export const SET_INCORRECT_OTP = "SET_INCORRECT_OTP";
export const FETCH_GET_CHECK_MOBILE_NUMBER = "FETCH_GET_CHECK_MOBILE_NUMBER";
export const FETCH_GET_CHECK_MOBILE_NUMBER_SUCCESS = "FETCH_GET_CHECK_MOBILE_NUMBER_SUCCESS";
export const FETCH_GET_CHECK_MOBILE_NUMBER_ERROR = "FETCH_GET_CHECK_MOBILE_NUMBER_ERROR";
export const FETCH_VERIFY_PASSWORD = "FETCH_VERIFY_PASSWORD";
export const FETCH_VERIFY_PASSWORD_SUCCESS = "FETCH_VERIFY_PASSWORD_SUCCESS";
export const FETCH_VERIFY_PASSWORD_ERROR = "FETCH_VERIFY_PASSWORD_ERROR";
export const FETCH_UPDATE_USER_PASSWORD = "FETCH_UPDATE_USER_PASSWORD";
export const FETCH_UPDATE_USER_PASSWORD_SUCCESS = "FETCH_UPDATE_USER_PASSWORD_SUCCESS";
export const FETCH_UPDATE_USER_PASSWORD_ERROR = "FETCH_UPDATE_USER_PASSWORD_ERROR";
export const FETCH_USER_LOGIN = "FETCH_USER_LOGIN";
export const FETCH_USER_LOGIN_SUCCESS = "FETCH_USER_LOGIN_SUCCESS";
export const FETCH_USER_LOGIN_ERROR = "FETCH_USER_LOGIN_ERROR";
export const FETCH_PARTNER_DETAILS = "FETCH_PARTNER_DETAILS";

// User
export const FETCH_GET_AGENT_DETAILS = "FETCH_GET_AGENT_DETAILS";
export const FETCH_GET_AGENT_DETAILS_SUCCESS = "FETCH_GET_AGENT_DETAILS_SUCCESS";
export const FETCH_GET_AGENT_DETAILS_ERROR = "FETCH_GET_AGENT_DETAILS_ERROR";
export const FETCH_GET_AGENT_CERTIFICATES = "FETCH_GET_AGENT_CERTIFICATES";
export const FETCH_GET_AGENT_CERTIFICATES_SUCCESS = "FETCH_GET_AGENT_CERTIFICATES_SUCCESS";
export const FETCH_GET_USER_PROFILE_INFO = "FETCH_GET_USER_PROFILE_INFO";
export const FETCH_GET_USER_PROFILE_INFO_SUCCESS = "FETCH_GET_USER_PROFILE_INFO_SUCCESS";
export const FETCH_GET_USER_PROFILE_INFO_ERROR = "FETCH_GET_USER_PROFILE_INFO_ERROR";
export const FETCH_GET_AGENT_PROFILE_PIC = "FETCH_GET_AGENT_PROFILE_PIC";
export const FETCH_GET_AGENT_PROFILE_PIC_SUCCESS = "FETCH_GET_AGENT_PROFILE_PIC_SUCCESS";
export const FETCH_GET_DIWALI_PDF = "FETCH_GET_DIWALI_PDF";
export const FETCH_GET_DIWALI_PDF_SUCCESS = "FETCH_GET_DIWALI_PDF_SUCCESS";
export const FETCH_GET_CUSTOMER_COUNT = "FETCH_GET_CUSTOMER_COUNT";
export const FETCH_GET_CUSTOMER_COUNT_SUCCESS = "FETCH_GET_CUSTOMER_COUNT_SUCCESS";
export const FETCH_GET_CUSTOMER_ORDER_DETAILS = "FETCH_GET_CUSTOMER_ORDER_DETAILS";
export const FETCH_GET_CUSTOMER_ORDER_DETAILS_SUCCESS = "FETCH_GET_CUSTOMER_ORDER_DETAILS_SUCCESS";
export const FETCH_GET_CALCULATOR_LEADS_COUNT = "FETCH_GET_CALCULATOR_LEADS_COUNT";
export const FETCH_GET_CALCULATOR_LEADS_COUNT_SUCCESS = "FETCH_GET_CALCULATOR_LEADS_COUNT_SUCCESS";
export const FETCH_POST_MERGE_CARTS = "FETCH_POST_MERGE_CARTS";
export const FETCH_POST_MERGE_CARTS_SUCCESS = "FETCH_POST_MERGE_CARTS_SUCCESS";
export const FETCH_GET_AGENT_VERIFICATION = "FETCH_GET_AGENT_VERIFICATION";
export const FETCH_GET_AGENT_VERIFICATION_SUCCESS = "FETCH_GET_AGENT_VERIFICATION_SUCCESS";

// Cart
export const FETCH_CART_DETAILS = "FETCH_CART_DETAILS";
export const FETCH_CART_DETAILS_SUCCESS = "FETCH_CART_DETAILS_SUCCESS";
export const FETCH_CART_DETAILS_ERROR = "FETCH_CART_DETAILS_ERROR";

// Premium service
export const FETCH_SHARE_PREMIUM_SERVICE = "FETCH_SHARE_PREMIUM_SERVICE";
export const FETCH_SHARE_PREMIUM_SERVICE_SUCCESS = "FETCH_SHARE_PREMIUM_SERVICE_SUCCESS";
export const FETCH_SHARE_PREMIUM_SERVICE_FAILURE = "FETCH_SHARE_PREMIUM_SERVICE_FAILURE";
export const RESET_SHARE_PREMIUM_SERVICE = "RESET_SHARE_PREMIUM_SERVICE";

// Share
export const SHOW_SHARE_POPUP = "SHOW_SHARE_POPUP";
export const HIDE_SHARE_POPUP = "HIDE_SHARE_POPUP";
export const FETCH_SHARE_URL_CONTENT = "FETCH_SHARE_URL_CONTENT";
export const FETCH_SHARE_URL_CONTENT_SUCCESS = "FETCH_SHARE_URL_CONTENT_SUCCESS";
export const FETCH_SHARE_URL_CONTENT_FAILURE = "FETCH_SHARE_URL_CONTENT_FAILURE";

// Share
export const SHOW_FILTERSORT_POPUP = "SHOW_FILTERSORT_POPUP";
export const HIDE_FILTERSORT_POPUP = "HIDE_FILTERSORT_POPUP";

// Create lead
export const FETCH_CREATE_LEAD = "FETCH_CREATE_LEAD";
export const SET_LEAD_CREATED = "SET_LEAD_CREATED";
export const SET_FAILED_TO_CREATE_LEAD = "SET_FAILED_TO_CREATE_LEAD";

//Check KYC Status
export const FETCH_CHECK_KYC_STATUS = "FETCH_CHECK_KYC_STATUS";
export const FETCH_CHECK_KYC_STATUS_SUCCESS= "FETCH_CHECK_KYC_STATUS_SUCCESS";
export const FETCH_CHECK_KYC_STATUS_ERROR = "FETCH_CHECK_KYC_STATUS_ERROR";

export const SET_INVESTOR_DETAILS = "SET_INVESTOR_DETAILS";

export const FETCH_CHECK_BSE_STATUS = "FETCH_CHECK_BSE_STATUS";
export const FETCH_CHECK_BSE_STATUS_SUCCESS= "FETCH_CHECK_BSE_STATUS_SUCCESS";
export const FETCH_CHECK_BSE_STATUS_FAILURE = "FETCH_CHECK_BSE_STATUS_FAILURE";

export const FETCH_POST_CANCEL_UPLOAD_CHEQUE = "FETCH_POST_CANCEL_UPLOAD_CHEQUE";
export const FETCH_POST_CANCEL_UPLOAD_CHEQUE_SUCCESS= "FETCH_POST_CANCEL_UPLOAD_CHEQUE_SUCCESS";
export const FETCH_POST_CANCEL_UPLOAD_CHEQUE_FAILURE = "FETCH_POST_CANCEL_UPLOAD_CHEQUE_FAILURE";

export const FETCH_UPLOAD_SIGNATURE = "FETCH_UPLOAD_SIGNATURE";
export const FETCH_UPLOAD_SIGNATURE_SUCCESS= "FETCH_UPLOAD_SIGNATURE_SUCCESS";
export const FETCH_UPLOAD_SIGNATURE_FAILURE = "FETCH_UPLOAD_SIGNATURE_FAILURE";

//Check Pincode status
export const FETCH_GET_VERIFY_PINCODE = "FETCH_GET_VERIFY_PINCODE";
export const FETCH_GET_VERIFY_PINCODE_SUCCESS = "FETCH_GET_VERIFY_PINCODE_SUCCESS";
export const FETCH_GET_VERIFY_PINCODE_ERROR = "FETCH_GET_VERIFY_PINCODE_ERROR";

//Search IFSC
export const FETCH_GET_CHECK_IFSC = "FETCH_GET_CHECK_IFSC";
export const FETCH_GET_CHECK_IFSC_SUCCESS = "FETCH_GET_CHECK_IFSC_SUCCESS";
export const FETCH_GET_CHECK_IFSC_ERROR = "FETCH_GET_CHECK_IFSC_ERROR";

//action to set profileView object
export const SET_PROFILE_VIEW_OBJECT= "SET_PROFILE_VIEW_OBJECT";

//get profileView
export const FETCH_GET_PROFILE_VIEW = "FETCH_GET_PROFILE_VIEW";
export const FETCH_GET_PROFILE_VIEW_SUCCESS = "FETCH_GET_PROFILE_VIEW_SUCCESS";
export const FETCH_GET_PROFILE_VIEW_FAILURE = "FETCH_GET_PROFILE_VIEW_FAILURE";

export const FETCH_SAVE_PROFILE_VIEW = "FETCH_SAVE_PROFILE_VIEW";
export const FETCH_SAVE_PROFILE_VIEW_SUCCESS = "FETCH_SAVE_PROFILE_VIEW_SUCCESS";
export const FETCH_SAVE_PROFILE_VIEW_FAILURE = "FETCH_SAVE_PROFILE_VIEW_FAILURE";

export const FETCH_GET_PORTFOLIO_DETAILS = "FETCH_GET_PORTFOLIO_DETAILS";
export const FETCH_GET_PORTFOLIO_DETAILS_SUCCESS = "FETCH_GET_PORTFOLIO_DETAILS_SUCCESS";
export const FETCH_GET_PORTFOLIO_DETAILS_FAILURE = "FETCH_GET_PORTFOLIO_DETAILS_FAILURE";

export const SET_REQUEST_ID = "SET_REQUEST_ID";
export const SET_ENC_REQUIREMENT_ID = "SET_ENC_REQUIREMENT_ID";
export const SET_NAME_IN_HEADER = "SET_NAME_IN_HEADER";

export const SHOW_PAYMENT_MODE_POPUP = "SHOW_PAYMENT_MODE_POPUP";
export const HIDE_PAYMENT_MODE_POPUP = "HIDE_PAYMENT_MODE_POPUP";

export const UPDATE_PROFILE_VIEW_ERROR = "UPDATE_PROFILE_VIEW_ERROR";

//RISK-PROFILE
export const FETCH_GET_RISK_PROFILE_RESULT = "FETCH_GET_RISK_PROFILE_RESULT";
export const FETCH_GET_RISK_PROFILE_RESULT_SUCCESS = "FETCH_GET_RISK_PROFILE_RESULT_SUCCESS";
export const FETCH_GET_RISK_PROFILE_RESULT_FAILURE = "FETCH_GET_RISK_PROFILE_RESULT_FAILURE";
//PAYMENT-FLOW
export const UPDATE_USER_PAYMENT_DETAIL_VIEW = "UPDATE_USER_PAYMENT_DETAIL_VIEW";
export const UPDATE_TOTAL_VALID_ORDERS_AMOUNT = "UPDATE_TOTAL_VALID_ORDERS_AMOUNT";
export const UPDATE_LOOP_BACK_URL = "UPDATE_LOOP_BACK_URL";
export const SHOW_PENDING_ORDER_POPUP = "SHOW_PENDING_ORDER_POPUP";
export const HIDE_PENDING_ORDER_POPUP = "HIDE_PENDING_ORDER_POPUP";
export const SET_ORDER_DETAILS_LIST = "SET_ORDER_DETAILS_LIST";
export const SET_PAYMENT_URL = "SET_PAYMENT_URL";

//flash
export const SHOW_FLASH_MESSAGE = "SHOW_FLASH_MESSAGE";
export const HIDE_FLASH_MESSAGE = "HIDE_FLASH_MESSAGE";

//mandate
export const FETCH_GET_USER_MANDATES_LIST = "FETCH_GET_USER_MANDATES_LIST";
export const FETCH_GET_USER_MANDATES_LIST_SUCCESS = "FETCH_GET_USER_MANDATES_LIST_SUCCESS";
export const FETCH_GET_USER_MANDATES_LIST_FAILURE = "FETCH_GET_USER_MANDATES_LIST_FAILURE";
export const SET_MANDATE_ACTIVATE_CONFIG = "SET_MANDATE_ACTIVATE_CONFIG";

//NFO
export const SET_NFO_APPLIED_FILTER_LIST = "SET_NFO_APPLIED_FILTER_LIST";
export const SET_NFO_APPLIED_SORT_LIST = "SET_NFO_APPLIED_SORT_LIST";

//calculator
export const SET_SHARE_CALCULATOR_CONFIG = "SET_SHARE_CALCULATOR_CONFIG";
export const SET_SHARE_CALCULATOR_CUSTOMER_DETAILS = "SET_SHARE_CALCULATOR_CUSTOMER_DETAILS";
export const SHARE_CALCULATOR_VIA_WHATSAPP = "SHARE_CALCULATOR_VIA_WHATSAPP";
export const SET_CUSTOMER_FROM_SHARED_LINK_DETAILS = "SET_CUSTOMER_FROM_SHARED_LINK_DETAILS";
export const SET_SIP_LUMPSUM_CALCULATOR_FORM_CHANGES = "SET_SIP_LUMPSUM_CALCULATOR_FORM_CHANGES";

//on app render
export const FETCH_GET_ALL_MINTPACKS = "FETCH_GET_ALL_MINTPACKS";
export const FETCH_GET_ALL_MINTPACKS_SUCCESS = "FETCH_GET_ALL_MINTPACKS_SUCCESS";
